module.exports = __webpack_public_path__ + "img/check-heart.c6c3fbfc.svg";